<template>
  <div class="animated-shape"
       :class="{
         'visible': visible,
         'loop': loop
        }" v-if="id">
    <svg :class="svgClasses()" viewBox="0 0 370 370">
      <path v-if="id === 'infinity'" ref="svgPath" class="animated-path" d="M77.000,115.000 C51.285,115.000 6.000,133.497 6.000,186.000 C6.000,234.469 48.702,256.000 76.000,256.000 C131.268,256.000 176.247,195.248 185.000,185.000 C196.760,171.231 245.754,115.000 292.000,115.000 C339.246,115.000 364.000,153.892 364.000,183.000 C364.000,212.108 345.754,256.000 293.000,256.000 C243.783,256.000 197.461,199.638 185.000,185.000 C118.977,107.443 77.000,115.000 77.000,115.000"/>
      <path v-if="id === 'orbit'" ref="svgPath" class="animated-path" d="M201.000,238.000 C201.000,238.000 18.903,288.388 5.000,239.000 C-5.101,203.118 105.357,152.742 160.000,135.000 C200.199,121.948 351.056,86.914 365.000,129.000 C382.703,182.431 201.000,238.000 201.000,238.000 "/>
      <path v-if="id === 'square'" stroke-dasharray="650" d="M185.000,55.000 L55.000,185.000 L185.000,315.000 L315.000,185.000 L185.000,55.000 "/>
      <g v-if="id === 'circle'">
        <path d="M185.000,55.000 C256.797,55.000 315.000,113.203 315.000,185.000 C315.000,256.797 256.797,315.000 185.000,315.000 C113.203,315.000 55.000,256.797 55.000,185.000 C55.000,113.203 113.203,55.000 185.000,55.000 Z"/>
        <path d="M185.000,288.519 C127.828,288.519 81.481,242.172 81.481,185.000 C81.481,184.193 81.524,183.396 81.542,182.593 "/>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'AnimatedShape',
  props: ['id', 'loop', 'color', 'visible'],
  methods: {
    svgClasses () {
      let retClasses = []
      let availableColors = ['accent', 'gray', 'text']

      if (this.color) {
        retClasses.push(this.color && availableColors.indexOf(this.color) !== -1 ? 'line-' + this.color : '')
      }
      if (this.loop) {
        retClasses.push('loop')
      }

      return retClasses.join(' ')
    },
    setLines () {
      if (!this.$refs.svgPath) { return false }
      const lineLength = Math.ceil(this.$refs.svgPath.getTotalLength())

      this.$refs.svgPath.setAttribute('stroke-dasharray', Math.ceil(lineLength * 0.92))
      this.$refs.svgPath.style.animationDuration = Math.ceil(lineLength * 10) + 'ms'
    }
  },
  mounted () {
    this.setLines()
  }
}
</script>

<style scoped lang="scss">
.animated-shape {

  svg {
    fill: none !important;
    stroke-width: 2;
    height: 100%;
    width: 100%;

    &.line-gray {
      stroke-width: 4;
    }
  }

  .animated-path {
    stroke-dashoffset: 0;
  }

  &.visible {
    .animated-path {
      animation: dash 1 linear forwards;
    }
  }
  &.loop {
    .animated-path {
      animation-iteration-count: infinite
    }
  }

  @each $id, $color in (
    'accent': $text-accent,
    'gray': $color-gray-line,
    'text': $text-dark
  ) {
    .line-#{$id} {
      stroke: $color;
    }
  }

} // END .animated-shape;
@keyframes dash {
  to {
    stroke-dashoffset: 5000;
  }
}
</style>
